import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  dateForList,
  dateForListWithHours,
} from "../../../../constants/dataFormat";
import {
  CNPJFormater,
  CPFFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";
import InfoCardsDetalhamento from "../../boletos/defaultComponents/InfoCardsDetalhamento";
import { useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

// Define the interface for the item prop to match objetoSalesList
interface objetoSalesList {
  id: string; // Top-level ID (e.g., df57a6a1-4ce1-4b84-c11a-08ddcde635b1)
  idCliente: number;
  bandeira: string;
  clienteNome: string | null;
  cnpj: string;
  dataCriacao: string;
  dataExpiracao: string | null;
  dataPagamento: string | null;
  isCnpj: boolean;
  nomeFantasia: string;
  razaoSocial: string;
  status: string;
  taxaCliente: number;
  taxaPlano: number;
  valor: number;
  valorLiquido: number;
  barcode?: string;
  emv?: string;
  mensagem?: string;
  urlBoleto?: string | null;
  transacao?: {
    id: number; // transacao.id (e.g., 12136290)
    idTransacao: string;
    [key: string]: any;
  };
}

interface ModalDetailVendaBoletoProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  item: objetoSalesList | {};
}

export default function ModalDetailVendaBoleto({
  isOpen,
  setIsOpen,
  item,
}: ModalDetailVendaBoletoProps) {
  const [colors] = useRecoilState(customColors);
  const [objetoPagamento, setObjetoPagamento] = useState<
    { titulo: string; valor: string }[]
  >([]);
  const [objetoBeneficiario, setObjetoBeneficiario] = useState<
    { titulo: string; valor: string }[]
  >([]);
  const [objetoFixo, setObjetoFixo] = useState<
    { titulo: string; valor: string }[]
  >([
    {
      titulo: "CPF/CNPJ do Beneficiário",
      valor: "19.468.242/0001-32",
    },
    { titulo: "Razão Social", valor: "IFOOD PAGO INSTITUICAO DE PAGAMENTO S.A." },
  ]);

  useEffect(() => {
    if (item && Object.keys(item).length !== 0) {
      const sale = item as objetoSalesList;

      const gerarObjetoPagamento = () => [
        {
          titulo: "Status",
          valor:
            sale.status === "pending"
              ? "Pendente"
              : sale.status === "succeeded"
              ? "Sucesso"
              : sale.status === "failed"
              ? "Falhou"
              : sale.status === "new"
              ? "Nova"
              : sale.status === "chargeback"
              ? "ChargeBack"
              : sale.status === "canceled"
              ? "Cancelado"
              : sale.status || "Desconhecido",
        },
        {
          titulo: "Data de Criação",
          valor: sale.dataCriacao
            ? moment(sale.dataCriacao).format(dateForListWithHours)
            : "N/A",
        },
        {
          titulo: "Data do Vencimento",
          valor: sale.dataExpiracao
            ? moment(sale.dataExpiracao).format(dateForList)
            : "N/A",
        },
        /*  {
          titulo: "Data de Pagamento",
          valor: sale.dataPagamento
            ? moment(sale.dataPagamento).format(dateForList)
            : "N/A",
        }, */
        {
          titulo: "Valor Total",
          valor: ToLocaleFormat(sale.valor) || "R$ 0,00",
        },
        /*      {
          titulo: "Valor Líquido",
          valor: ToLocaleFormat(sale.valorLiquido) || "R$ 0,00",
        }, */
        /*    {
          titulo: "Taxa Cliente",
          valor: ToLocaleFormat(sale.taxaCliente) || "R$ 0,00",
        }, */
        /*    {
          titulo: "Taxa Plano",
          valor: sale.taxaPlano ? `${sale.taxaPlano}%` : "0%",
        }, */
        { titulo: "Código de Barras", valor: sale.barcode || "N/A" },
        { titulo: "EMV (PIX)", valor: sale.emv || "N/A" },
        { titulo: "Mensagem", valor: sale.mensagem || "N/A" },
      ];

      const gerarObjetoBeneficiario = () => {
        const cnpjOrCpf = sale.cnpj
          ? sale.cnpj.length === 11
            ? CPFFormater(sale.cnpj)
            : CNPJFormater(sale.cnpj)
          : "N/A";

        return [
          {
            titulo: "CPF/CNPJ do Beneficiário",
            valor: cnpjOrCpf,
          },
          { titulo: "Razão Social", valor: sale.razaoSocial || "N/A" },
          { titulo: "Nome Fantasia", valor: sale.nomeFantasia || "N/A" },
        ];
      };

      setObjetoPagamento(gerarObjetoPagamento());
      setObjetoBeneficiario(gerarObjetoBeneficiario());
    } else {
      setObjetoPagamento([]);
      setObjetoBeneficiario([]);
    }
  }, [item]);

  const abrirBoleto = (id: string | undefined) => {
    if (id) {
      const url = `https://m2admin.softkuka.com.br/bolepix/view/${id}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const onClose = () => setIsOpen(false);

  const sale = item as objetoSalesList;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(8px)" />
      <ModalContent
        borderRadius="lg"
        boxShadow="lg"
        bg="white"
        p={4}
        maxHeight="80vh"
      >
        <ModalHeader
          textAlign="center"
          fontSize="xl"
          fontWeight="semibold"
          color="gray.800"
        >
          Detalhes do Pagamento
        </ModalHeader>
        {item && Object.keys(item).length !== 0 ? (
          <ModalBody overflowY="auto" maxHeight="60vh">
            <VStack spacing={6} align="stretch">
              <Box
                borderWidth="1px"
                borderColor="gray.200"
                borderRadius="md"
                p={4}
                bg="gray.50"
              >
                <InfoCardsDetalhamento
                  title="Informações do Pagamento"
                  array={objetoPagamento}
                />
              </Box>
              <Box
                borderWidth="1px"
                borderColor="gray.200"
                borderRadius="md"
                p={4}
                bg="gray.50"
              >
                <InfoCardsDetalhamento
                  title="Informações do Beneficiário"
                  array={objetoBeneficiario}
                />
              </Box>
              <Box
                borderWidth="1px"
                borderColor="gray.200"
                borderRadius="md"
                p={4}
                bg="gray.50"
              >
                <InfoCardsDetalhamento
                  title="Informações Fixas"
                  array={objetoFixo}
                />
              </Box>
              {sale.id ? (
                <Box
                  borderWidth="1px"
                  borderColor="gray.200"
                  borderRadius="md"
                  overflow="hidden"
                  height="400px"
                >
                  <iframe
                    src={`https://m2admin.softkuka.com.br/bolepix/view/${sale.id}`}
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                    title="Visualização do Boleto"
                  />
                </Box>
              ) : (
                <Box
                  borderWidth="1px"
                  borderColor="gray.200"
                  borderRadius="md"
                  p={4}
                  bg="gray.50"
                  textAlign="center"
                >
                  <Text color="gray.500">Boleto não disponível</Text>
                </Box>
              )}
            </VStack>
          </ModalBody>
        ) : (
          <ModalBody overflowY="auto" maxHeight="60vh">
            <Text textAlign="center" color="gray.500">
              Nenhuma informação disponível
            </Text>
          </ModalBody>
        )}
        <ModalFooter justifyContent="center" gap={4}>
          <Button
            bg={colors.BLUEMONEDDBUTTONS}
            color="white"
            px={6}
            borderRadius="md"
            _hover={{ bg: colors.BLUEMONEDDBUTTONS, opacity: 0.9 }}
            onClick={() => abrirBoleto(sale.id)}
            isDisabled={!sale.id}
          >
            Abrir Boleto
          </Button>
          <Button
            bg="gray.500"
            color="white"
            px={6}
            borderRadius="md"
            _hover={{ bg: "gray.600" }}
            onClick={onClose}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
